import { gql } from "graphql-request";

// ===== Category Mutations =====

export const ADMIN_CREATE_CHANGELOG_CATEGORY = gql`
  mutation AdminCreateChangelogCategory(
    $input: AdminCreateChangelogCategoryInputDto!
  ) {
    adminCreateChangelogCategory(input: $input) {
      _id
      name {
        ko
        en
      }
      color
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

export const ADMIN_UPDATE_CHANGELOG_CATEGORY = gql`
  mutation AdminUpdateChangelogCategory(
    $input: AdminUpdateChangelogCategoryInputDto!
  ) {
    adminUpdateChangelogCategory(input: $input) {
      _id
      name {
        ko
        en
      }
      color
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

export const ADMIN_DELETE_CHANGELOG_CATEGORY = gql`
  mutation AdminDeleteChangelogCategory($categoryId: String!) {
    adminDeleteChangelogCategory(categoryId: $categoryId) {
      success
      message
    }
  }
`;

// ===== Entry Mutations =====

export const ADMIN_CREATE_CHANGELOG_ENTRY = gql`
  mutation AdminCreateChangelogEntry(
    $input: AdminCreateChangelogEntryInputDto!
  ) {
    adminCreateChangelogEntry(input: $input) {
      _id
      title {
        ko
        en
      }
      body {
        ko
        en
      }
      featuredImageUrl
      categories {
        _id
        name {
          ko
          en
        }
        color
      }
      status
      publishedAt
      createdAt
      updatedAt
    }
  }
`;

export const ADMIN_UPDATE_CHANGELOG_ENTRY = gql`
  mutation AdminUpdateChangelogEntry(
    $input: AdminUpdateChangelogEntryInputDto!
  ) {
    adminUpdateChangelogEntry(input: $input) {
      _id
      title {
        ko
        en
      }
      body {
        ko
        en
      }
      featuredImageUrl
      categories {
        _id
        name {
          ko
          en
        }
        color
      }
      status
      publishedAt
      createdAt
      updatedAt
    }
  }
`;

export const ADMIN_PUBLISH_CHANGELOG_ENTRY = gql`
  mutation AdminPublishChangelogEntry($entryId: String!) {
    adminPublishChangelogEntry(entryId: $entryId) {
      success
      message
    }
  }
`;

export const ADMIN_UNPUBLISH_CHANGELOG_ENTRY = gql`
  mutation AdminUnpublishChangelogEntry($entryId: String!) {
    adminUnpublishChangelogEntry(entryId: $entryId) {
      success
      message
    }
  }
`;

export const ADMIN_DELETE_CHANGELOG_ENTRY = gql`
  mutation AdminDeleteChangelogEntry($entryId: String!) {
    adminDeleteChangelogEntry(entryId: $entryId) {
      success
      message
    }
  }
`;

// ===== AI Draft Generation =====

export const ADMIN_GENERATE_CHANGELOG_DRAFT = gql`
  mutation AdminGenerateChangelogDraft(
    $input: AdminGenerateChangelogDraftInputDto!
  ) {
    adminGenerateChangelogDraft(input: $input) {
      titleKo
      titleEn
      bodyKo
      bodyEn
      categoryIds
      imagePlaceholders
    }
  }
`;

// ===== Tweet Generation =====

export const ADMIN_GENERATE_CHANGELOG_TWEET = gql`
  mutation AdminGenerateChangelogTweet($entryId: String!) {
    adminGenerateChangelogTweet(entryId: $entryId) {
      tweet
    }
  }
`;
